import { Modal, Button } from "@hiya/ui";

interface ConfirmPublishModalProps {
  open: boolean;
  title: string;
  message: string;
  publishing: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function ConfirmPublishModal({
  open,
  title,
  message,
  publishing,
  onClose,
  onConfirm,
}: ConfirmPublishModalProps) {
  return (
    <Modal open={open} title={title} onClose={onClose}>
      <p className="text-base text-text-secondary">{message}</p>
      <div className="flex gap-3 mt-4">
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={publishing}>
          {publishing ? "Publishing..." : "Publish"}
        </Button>
      </div>
    </Modal>
  );
}
